@if (client$ | async; as client) {
    <h1 mat-dialog-title>Create Access Token</h1>
    <div mat-dialog-content>
        <form [formGroup]="form">
            <div class="flex column">
                <mat-form-field>
                    <mat-label>Token Name</mat-label>
                    <input matInput formControlName="title" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                </mat-form-field>
                <frog-user-picker
                    label="Owner"
                    [multiple]="false"
                    formControlName="owner"
                ></frog-user-picker>
                <mat-form-field>
                    <mat-label>Expires</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="expires" />
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div mat-dialog-actions>
        <button mat-button color="primary" [disabled]="!form.valid" (click)="createToken(client)">
            Create
        </button>
        <button mat-button mat-dialog-close>Cancel</button>
    </div>
}
